import React from "react"
import { useStaticQuery, graphql } from "gatsby"

// COPY FROM HERE
// 0. Move header image from original header component to src/images
// 1. Update value of variables above
// 2. Update children of SecondaryNavigation if needed
// 3. Update children of About
import Layout from '../../components/layout'
import About from '../../components/aboutpocwrap'

import { SecondaryNavigation } from '../../components/navigation'
import headerImage from '../../images/powerofcloudHeader2.png'

import "../../style/main.scss"

// initialize page data
const pageTitle = 'Leveraging AWS Cloud to power clinical research'
const pageNavigation = {
  type: 'horizontal',
  items: [
    {
      title: 'Webinars',
      url: '/',
    },
    
  ]
}

const headerimageAltText = 'Leveraging AWS Cloud to power clinical research'

const eventBriteId = '137497138643'
const eventBriteModalTriggerElementId = 'eventbrite-widget-modal-trigger-137497138643'
const eventBriteNoScriptUri = 'https://www.eventbrite.com/e/the-power-of-cloud-registration-137497138643'

const layoutNavigation = ''
const layoutHeaderImage = ''

const aboutDetails = [
  {
    'key': 'Date',
    'value': '03.25.21'
  },
  {
    'key': 'Time',
    'value': '12:00 PM - 1:00 PM EST'
  }
]
const aboutCtaText = 'WATCH NOW »'
const aboutCtaClassNames = 'regworkwatch'
const aboutCtaClassNamesMobile = 'regmobwatch'

const sponsorEventName = 'mar25'
const sponsorPDFUrl = 'https://s3.amazonaws.com/sng-global-web-assets/sponsors/SNGLIVE_SponsorPackageV2.pdf'
const sponsorsClassNames = 'grouplogos'


const IndexPage = () => {
  const data = useStaticQuery(graphql`
      query {
        site {
          siteMetadata {
            speakers {
              name
              title
              image
              disabledProfile
              event
            }
            sponsorshipLevel
            sponsors {
              name
              level
              logo
              url
              width
              event
            }
            sessions {
              startTime
              endTime
              title
              description
              type
              speakers {
                name
                isModerator
              }
              event
            }
          }
        }
      }
    `)

  const {
    speakers,
    sessions,
    sponsors,
    sponsorshipLevel
  } = data.site.siteMetadata

  return (
    <Layout
      title={pageTitle}
      eventBriteId={eventBriteId}
      eventBriteModalTriggerElementId={eventBriteModalTriggerElementId}
      eventBriteNoScriptUri={eventBriteNoScriptUri}
      navigation={pageNavigation}
      headerImage={{
        imageUri: headerImage,
        imageMobileUril: headerImage,
        imageAltText: headerimageAltText
      }} >
      <SecondaryNavigation>
        <a className='subNavButton' href="https://www.fedscoop.com/events/deloitte-innovation-in-federal-health/power-of-cloud/#Speakers">SPEAKERS</a>
        <a className='subNavButton' href="https://www.fedscoop.com/events/deloitte-innovation-in-federal-health/power-of-cloud/wrap-up" target="_blank">WRAP-UP</a>
      </SecondaryNavigation>
      <About
        details={aboutDetails}
        ctaText={aboutCtaText}
        ctaId={eventBriteModalTriggerElementId}
        ctaClassNames={aboutCtaClassNames}
        ctaClassNamesMobile={aboutCtaClassNamesMobile}
        sponsorPDFUrl={sponsorPDFUrl}
        sponsorEventName={sponsorEventName}
        sponsors={sponsors}
        sponsorsClassNames={sponsorsClassNames}
        sponsorshipLevel={sponsorshipLevel} >
          <a href="https://event.on24.com/wcc/r/3079073/AE4A96B96479FBC8EFDE6DF7E8043358" target="_blank" className="greenme">Watch the on-demand session from The Power of Cloud: Leveraging AWS Cloud to Power Clinical Research</a>.<br /><br />

In our first webinar of this four-part series, we explored how Cloud enables public sector health organizations to increase responsiveness, flexibility, and innovation on how their missions are delivered.<br /><br />

During the session, leaders from the Crohn’s and Colitis Foundation highlighted how AWS cloud and Deloitte have played key roles in powering its IBD Plexus platform to accelerate research on the conditions. Joined by experts from AWS and Deloitte, they also touched more broadly on the role cloud will continue to play in transforming health care in the near future.
      </About>

    </Layout>
  )
}

export default IndexPage
// COPY STOPS HERE